import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import qs from 'qs';
import moment from "moment";

const NewDate    = moment().format('YYYY-MM-DD')

class Forms extends Component {
	constructor(props) {
		super(props);

		this.state = {
            diskon_desc:"",
            diskon_nominal:"",
            diskon_nama:"",
			date: "",
			diskon_id:"",
			created_by:"",
			modified_by: "",
			isButtonLoading: false,
			isLoading   : false,
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
    }

    handleSubmit() {
        let formData = new FormData();
        const config = {
			headers: { "content-type": "multipart/form-data" }
		};

		formData.append("created_by", localStorage.SISMART_USER_ID);
		formData.append("modified_by", localStorage.SISMART_USER_ID);
		formData.append("diskon_id", this.state.diskon_id);
		formData.append("diskon_nama", this.state.diskon_nama);
		formData.append("diskon_desc", this.state.diskon_desc);
		formData.append("diskon_nominal", this.state.diskon_nominal);

		const url = this.props.mode === "Tambah" ? "/iuran/diskon/add" : "/iuran/diskon/update";

		this.setState({ isButtonLoading: true });

		axios.post(url, formData, config)
			.then(response => {
                
				const result = response.data;

				if (result.success) {
					Alert.success(result.message);
					this.props.history.replace("/diskoniuran");
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);

							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			}); 
	}

	loadData() {
        if (this.props.mode === "Edit") {
            this.setState({isLoading: true});

            const params = qs.stringify({
                diskon_id: this.props.match.params.diskon_id
            })

            axios({
                method: "get",
                url: "/iuran/diskon/" + this.props.match.params.diskon_id + "?" +params
            })

                .then(response => {
                    const result = response.data;

                    if (result.success) {
                        this.setState({
                            created_by:result.data.created_by,
                            modified_by:result.data.modified_by,
                            diskon_nama:result.data.diskon_nama,
                            diskon_id:result.data.diskon_id,
                            diskon_desc: result.data.diskon_desc,
                            diskon_nominal: result.data.diskon_nominal,
                            pageCount: result.data.last_page,
                            isLoading: false,
                            isButtonLoading: false
                        });
                    } else {
                        Alert.error(result.message);
                    }

                    this.setState({isLoading: false});
                })
                .catch(error => {
                    console.log(error);
                    Alert.error("Gagal terhubung ke server!");
                    this.setState({isLoading: false});
                });
        }
    }


	
	componentDidMount() {
		this.loadData();
	}

	render() {
		return (
			<div className="col-sm-12">
				<div className="card">
					<div className="card-header">{this.props.mode} Diskon Tagihan</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : (
							<div className="form-horizontal animated fadeIn" name="created_by" value={localStorage.SISMART_USER_ID}>
								<div className="form-group row" name="modified_by" value={localStorage.SISMART_USER_ID}>
									<label className="col-md-2 form-control-label">
									Diskon
									</label>
									<div className="col-md-4">
										<input
											name="diskon_nama"
											type="text"
											className="form-control"
											placeholder="Diskon"
											onChange={this.handleChange}
											value={this.state.diskon_nama}
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-md-2 form-control-label">
									Deskripsi
									</label>
									<div className="col-md-4">
										<input
											name="diskon_desc"
											type="text"
											className="form-control"
											placeholder="Deskripsi"
											onChange={this.handleChange}
											value={this.state.diskon_desc}
										/>
									</div>
								</div>
								<div className="form-group row">
									<label className="col-md-2 form-control-label">
										Nominal
									</label>
									<div className="col-md-4">
										<input
											name="diskon_nominal"
											type="text"
											className="form-control"
											placeholder="Nominal"
											onChange={this.handleChange}
											value={this.state.diskon_nominal}
										/>
									</div>
								</div>
							</div>
						)}
					</div>
					<div className="card-footer">
						<button
							type="button"
							className="btn btn-md btn-primary"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={this.handleSubmit}
						>
							{this.state.isButtonLoading ? "Loading" : "Simpan"}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default Forms;



// WEBPACK FOOTER //
// ./src/views/DiskonIuran/Forms.js